import React from "react";

const StarIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5026 3.59438L11.102 10.4894L3.49358 11.5986C2.12917 11.7965 1.58236 13.4786 2.57182 14.442L8.07635 19.8059L6.77443 27.3831C6.54008 28.7527 7.98261 29.7786 9.19079 29.1381L15.9972 25.5604L22.8037 29.1381C24.0119 29.7734 25.4544 28.7527 25.2201 27.3831L23.9181 19.8059L29.4227 14.442C30.4121 13.4786 29.8653 11.7965 28.5009 11.5986L20.8925 10.4894L17.4919 3.59438C16.8826 2.36536 15.1171 2.34974 14.5026 3.59438Z"
        fill={"#E5A800"}
      />
    </svg>
  );
};

export default StarIcon;
